import { safeErr, isValidEmail, isValidPhone } from '../App';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getLeads, getLeadsCount, sendEmail, deleteLead, bulkLeadsToContacts, updateLead, createLead, getLeadAddedByList, importLeadsFile } from '../api';

const SC = { sent:'s-sent', followup_1:'s-followup', followup_2:'s-followup',
  followup_3:'s-followup', replied:'s-replied', closed:'s-closed', new:'s-new', nurture:'s-nurture' };
const SL = { sent:'Sent', followup_1:'Follow-up 1', followup_2:'Follow-up 2',
  followup_3:'Follow-up 3', replied:'Replied', closed:'Closed', new:'New', nurture:'Nurture' };
const SECTORS = ['IT & Software','Healthcare','Manufacturing','Retail','Education','Logistics','Finance','Real Estate','Food & Agri'];
const PAGE_SIZE = 25;

// ── Edit Lead Modal ─────────────────────────────────────────────────────────
function EditModal({ lead, onClose, onSaved, showToast }) {
  const [f, setF] = useState({
    name: lead.name||'', email: lead.email||'', company: lead.company||'',
    role: lead.role||'', phone: lead.phone||'', sector: lead.sector||'', location: lead.location||'',
  });
  const [saving, setSave] = useState(false);
  const [err, setErr]     = useState('');
  const s = (k,v) => setF(p=>({...p,[k]:v}));

  const save = async () => {
    if (!f.name||!f.email) { setErr('Name and email are required'); return; }
    if (!isValidEmail(f.email)) { setErr('Enter a valid email address'); return; }
    if (!isValidPhone(f.phone)) { setErr('Enter a valid phone number'); return; }
    setSave(true); setErr('');
    try { await updateLead(lead.id, f); onSaved(); }
    catch(e) { setErr(safeErr(e,'Error saving lead')); }
    finally { setSave(false); }
  };

  return (
    <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&onClose()}>
      <div className="modal-box" style={{width:540}}>
        <div className="modal-header">
          <span className="modal-title">Edit lead</span>
          <button className="btn btn-ghost btn-icon" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body">
          {err && <div className="alert alert-error">{err}</div>}
          <div className="form-row">
            <div className="form-group"><label className="form-label">Full name *</label><input className="form-input" value={f.name} onChange={e=>s('name',e.target.value)}/></div>
            <div className="form-group"><label className="form-label">Email *</label><input className="form-input" type="email" value={f.email} onChange={e=>s('email',e.target.value)}/></div>
          </div>
          <div className="form-row">
            <div className="form-group"><label className="form-label">Company</label><input className="form-input" value={f.company} onChange={e=>s('company',e.target.value)}/></div>
            <div className="form-group"><label className="form-label">Role / Title</label><input className="form-input" value={f.role} onChange={e=>s('role',e.target.value)}/></div>
          </div>
          <div className="form-row">
            <div className="form-group"><label className="form-label">Phone</label><input className="form-input" type="tel" value={f.phone} onChange={e=>s('phone',e.target.value)}/></div>
            <div className="form-group"><label className="form-label">Sector</label>
              <select className="form-select" value={f.sector} onChange={e=>s('sector',e.target.value)}>
                <option value="">Select sector</option>
                {SECTORS.map(x=><option key={x}>{x}</option>)}
              </select>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group"><label className="form-label">Location</label><input className="form-input" value={f.location} onChange={e=>s('location',e.target.value)}/></div>
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-primary" disabled={saving} onClick={save}>{saving?'Saving…':'Save changes'}</button>
          <button className="btn" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
}

// ── Add Lead Modal ───────────────────────────────────────────────────────────
function AddModal({ onClose, onSaved }) {
  const [f, setF] = useState({name:'',email:'',company:'',role:'',phone:'',sector:'',location:''});
  const [saving, setSave] = useState(false);
  const [err, setErr]     = useState('');
  const s = (k,v) => setF(p=>({...p,[k]:v}));

  const save = async () => {
    if (!f.name||!f.email) { setErr('Name and email are required'); return; }
    if (!isValidEmail(f.email)) { setErr('Enter a valid email address'); return; }
    if (!isValidPhone(f.phone)) { setErr('Enter a valid phone number'); return; }
    setSave(true); setErr('');
    try { await createLead(f); onSaved(); }
    catch(e) { setErr(safeErr(e,'Error saving lead')); }
    finally { setSave(false); }
  };

  return (
    <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&onClose()}>
      <div className="modal-box" style={{width:540}}>
        <div className="modal-header">
          <span className="modal-title">Add new lead</span>
          <button className="btn btn-ghost btn-icon" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body">
          {err && <div className="alert alert-error">{err}</div>}
          <div className="form-row">
            <div className="form-group"><label className="form-label">Full name *</label><input className="form-input" value={f.name} onChange={e=>s('name',e.target.value)} placeholder="Rajesh Kumar"/></div>
            <div className="form-group"><label className="form-label">Email *</label><input className="form-input" type="email" value={f.email} onChange={e=>s('email',e.target.value)} placeholder="rajesh@company.com"/></div>
          </div>
          <div className="form-row">
            <div className="form-group"><label className="form-label">Company</label><input className="form-input" value={f.company} onChange={e=>s('company',e.target.value)} placeholder="Acme Corp"/></div>
            <div className="form-group"><label className="form-label">Role / Title</label><input className="form-input" value={f.role} onChange={e=>s('role',e.target.value)} placeholder="CEO"/></div>
          </div>
          <div className="form-row">
            <div className="form-group"><label className="form-label">Phone</label><input className="form-input" type="tel" value={f.phone} onChange={e=>s('phone',e.target.value)} placeholder="+91 98765 43210"/></div>
            <div className="form-group"><label className="form-label">Sector</label>
              <select className="form-select" value={f.sector} onChange={e=>s('sector',e.target.value)}>
                <option value="">Select sector</option>
                {SECTORS.map(x=><option key={x}>{x}</option>)}
              </select>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group"><label className="form-label">Location</label><input className="form-input" value={f.location} onChange={e=>s('location',e.target.value)} placeholder="Chennai, TN"/></div>
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-primary" disabled={saving} onClick={save}>{saving?'Saving…':'Save lead'}</button>
          <button className="btn" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
}

// ── Import from File Modal ─────────────────────────────────────────────────────
function ImportFileModal({ onClose, onSaved }) {
  const [file, setFile]     = useState(null);
  const [saving, setSave]   = useState(false);
  const [err, setErr]       = useState('');
  const [result, setResult] = useState(null);

  const doImport = async () => {
    if (!file) { setErr('Choose a CSV file first'); return; }
    setSave(true); setErr('');
    try {
      const r = await importLeadsFile(file);
      setResult(r.data);
      setTimeout(onSaved, 1800);
    } catch(e) { setErr(safeErr(e,'Import failed')); }
    finally { setSave(false); }
  };

  return (
    <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&onClose()}>
      <div className="modal-box" style={{width:480}}>
        <div className="modal-header">
          <span className="modal-title">Import leads from file</span>
          <button className="btn btn-ghost btn-icon" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body">
          {err && <div className="alert alert-error">{err}</div>}
          {result ? (
            <div style={{padding:'8px 0'}}>
              <div className="alert alert-success" style={{justifyContent:'center',fontSize:15}}>
                ✓ {result.added} leads imported
                {result.skipped ? `, ${result.skipped} duplicates skipped` : ''}
                {result.invalid ? `, ${result.invalid} invalid rows skipped` : ''}
              </div>
              {result.errors && result.errors.length > 0 && (
                <div style={{marginTop:10,fontSize:12,color:'var(--text-2)',maxHeight:140,overflow:'auto'}}>
                  {result.errors.map((e,i)=><div key={i}>{e}</div>)}
                </div>
              )}
            </div>
          ) : (
            <>
              <div className="form-group">
                <label className="form-label">CSV file</label>
                <input type="file" accept=".csv,text/csv" className="form-input"
                  onChange={e=>setFile(e.target.files[0]||null)}/>
              </div>
              <div style={{fontSize:12,color:'var(--text-2)'}}>
                Required columns: <b>name</b>, <b>email</b>. Optional: phone, company, role, sector, location.
              </div>
            </>
          )}
        </div>
        {!result && (
          <div className="modal-footer">
            <button className="btn btn-primary" disabled={saving||!file} onClick={doImport}>
              {saving?'Importing…':'Import leads'}
            </button>
            <button className="btn" onClick={onClose}>Cancel</button>
          </div>
        )}
      </div>
    </div>
  );
}

export default function Leads({ showToast }) {
  const [leads,    setLeads]    = useState([]);
  const [counts,   setCounts]   = useState({total:0});
  const [sector,   setSector]   = useState('');
  const [status,   setStatus]   = useState('');
  const [addedBy,  setAddedBy]  = useState('');
  const [adders,   setAdders]   = useState([]);
  const [search,   setSearch]   = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const [page,     setPage]     = useState(1);
  const [loading,  setLoading]  = useState(true);
  const [sending,  setSending]  = useState({});
  const [selected, setSelected] = useState(new Set());
  const [adding,   setAdding]   = useState(false);
  const [editing,  setEditing]  = useState(null);
  const [showAdd,  setShowAdd]  = useState(false);
  const [showImpFile, setShowImpFile] = useState(false);
  const nav = useNavigate();

  const totalPages = Math.max(1, Math.ceil(counts.total / PAGE_SIZE));

  // Debounce search input
  useEffect(()=>{ const t=setTimeout(()=>setDebouncedSearch(search),350); return()=>clearTimeout(t); },[search]);
  // Any filter change jumps back to page 1
  useEffect(()=>{ setPage(1); },[debouncedSearch,sector,status,addedBy]);

  const load = () => {
    setLoading(true);
    const params = {sector, status, search:debouncedSearch, added_by:addedBy, limit:PAGE_SIZE, offset:(page-1)*PAGE_SIZE};
    Promise.all([getLeads(params), getLeadsCount({sector,status,search:debouncedSearch,added_by:addedBy})])
      .then(([r, c]) => { setLeads(r.data); setCounts(c.data); setSelected(new Set()); })
      .finally(() => setLoading(false));
  };

  useEffect(() => { getLeadAddedByList().then(r => setAdders(r.data)); }, []);
  useEffect(load, [page, sector, status, addedBy, debouncedSearch]);

  const goToPage = p => { if (p>=1 && p<=totalPages) setPage(p); };

  const toggleOne = (id, e) => { e.stopPropagation(); setSelected(p => { const n = new Set(p); n.has(id) ? n.delete(id) : n.add(id); return n; }); };
  const toggleAll = () => setSelected(selected.size === leads.length ? new Set() : new Set(leads.map(l=>l.id)));
  const selList   = [...selected];

  const handleSend = async (id, e) => {
    e.stopPropagation();
    setSending(p => ({...p,[id]:true}));
    try { await sendEmail(id); showToast('Email sent!'); load(); }
    catch(e) { showToast(e.response?.data?.detail||'Send failed','error'); }
    finally  { setSending(p => ({...p,[id]:false})); }
  };

  const handleDelete = async (id, e) => {
    e.stopPropagation();
    if (!window.confirm('Delete this lead?')) return;
    await deleteLead(id);
    showToast('Lead deleted');
    // If that was the last lead on this page (and not page 1), step back a page
    if (leads.length===1 && page>1) setPage(page-1);
    else load();
  };

  const handleAddToContacts = async (ids) => {
    setAdding(true);
    try {
      const r = await bulkLeadsToContacts(ids);
      const { added, skipped } = r.data;
      showToast(`✓ ${added} added to contacts${skipped ? `, ${skipped} already existed` : ''}`);
      setSelected(new Set());
    } catch(e) { showToast('Failed to add contacts', 'error'); }
    finally { setAdding(false); }
  };

  return (
    <>
      {editing && (
        <EditModal lead={editing} onClose={()=>setEditing(null)}
          onSaved={()=>{setEditing(null);showToast('Lead updated');load();}} showToast={showToast}/>
      )}
      {showAdd && (
        <AddModal onClose={()=>setShowAdd(false)}
          onSaved={()=>{setShowAdd(false);showToast('Lead added');load();}}/>
      )}
      {showImpFile && (
        <ImportFileModal onClose={()=>setShowImpFile(false)}
          onSaved={()=>{setShowImpFile(false);showToast('Leads imported!');load();}}/>
      )}

      {/* Toolbar */}
      <div style={{display:'flex',gap:8,marginBottom:16,flexWrap:'wrap',alignItems:'center'}}>
        <input className="form-input" style={{width:210}} placeholder="Search name or company…"
          value={search} onChange={e=>setSearch(e.target.value)}/>
        <select className="form-select" style={{width:160}} value={sector} onChange={e=>setSector(e.target.value)}>
          <option value="">All sectors</option>
          {SECTORS.map(s=><option key={s}>{s}</option>)}
        </select>
        <select className="form-select" style={{width:145}} value={status} onChange={e=>setStatus(e.target.value)}>
          <option value="">All statuses</option>
          {Object.entries(SL).map(([v,l])=><option key={v} value={v}>{l}</option>)}
        </select>
        {adders.length > 0 && (
          <select className="form-select" style={{width:150}} value={addedBy} onChange={e=>setAddedBy(e.target.value)}>
            <option value="">Added by: anyone</option>
            {adders.map(a=><option key={a} value={a}>{a}</option>)}
          </select>
        )}

        {/* Bulk action bar */}
        {selList.length > 0 && (
          <div style={{display:'flex',alignItems:'center',gap:8,padding:'5px 12px',
            background:'var(--blue-bg)',border:'1px solid var(--blue-border)',borderRadius:'var(--r-lg)'}}>
            <span style={{fontSize:12,fontWeight:600,color:'var(--blue)'}}>{selList.length} selected</span>
            <button className="btn btn-success btn-sm" disabled={adding}
              onClick={() => handleAddToContacts(selList)}>
              {adding ? <><span className="spinner spinner-sm"/>Adding…</> : '👥 Add to contacts'}
            </button>
            <button className="btn btn-primary btn-sm"
              onClick={() => { /* send all selected */ selList.forEach(id => { const l=leads.find(x=>x.id===id); if(l?.status==='new') handleSend(id,{stopPropagation:()=>{}}); }); }}>
              ↑ Send emails
            </button>
            <button className="btn btn-ghost btn-sm" onClick={() => setSelected(new Set())}>Clear</button>
          </div>
        )}

        <div style={{marginLeft:'auto',display:'flex',gap:8}}>
          <button className="btn btn-sm" onClick={()=>setShowImpFile(true)}>↑ Import from file</button>
          <button className="btn btn-sm" onClick={()=>setShowAdd(true)}>+ Add lead</button>
          <button className="btn btn-primary btn-sm" onClick={()=>nav('/generate')}>
            ✦ Generate leads
          </button>
        </div>
      </div>

      <div className="card">
        {loading ? (
          <div className="loading-center"><div className="spinner spinner-md"/></div>
        ) : leads.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon">◎</div>
            <div className="empty-title">No leads yet</div>
            <div className="empty-desc">Add a lead manually or generate leads to start your outreach</div>
            <div style={{display:'flex',gap:8,justifyContent:'center'}}>
              <button className="btn btn-primary" onClick={()=>nav('/generate')}>✦ Generate leads</button>
              <button className="btn" onClick={()=>setShowAdd(true)}>+ Add lead</button>
              <button className="btn" onClick={()=>setShowImpFile(true)}>↑ Import from file</button>
            </div>
          </div>
        ) : (
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th style={{width:36}}>
                    <input type="checkbox" checked={leads.length>0&&selected.size===leads.length}
                      onChange={toggleAll} style={{accentColor:'var(--blue)',cursor:'pointer'}}/>
                  </th>
                  <th>Name</th><th>Company</th><th>Sector</th><th>Email</th><th>Status</th><th>Added by</th><th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {leads.map(l => (
                  <tr key={l.id} className={selected.has(l.id)?'selected':''}
                    onClick={()=>nav(`/leads/${l.id}`)}>
                    <td onClick={e=>toggleOne(l.id,e)}>
                      <input type="checkbox" checked={selected.has(l.id)} onChange={()=>{}}
                        style={{accentColor:'var(--blue)',cursor:'pointer'}}/>
                    </td>
                    <td style={{fontWeight:600,color:'var(--blue)'}}>{l.name}</td>
                    <td>{l.company}</td>
                    <td style={{color:'var(--text-2)',fontSize:12}}>{l.sector}</td>
                    <td className="mono" style={{color:'var(--text-2)',fontSize:12}}>{l.email}</td>
                    <td><span className={`pill ${SC[l.status]||'s-new'}`}>{SL[l.status]||l.status}</span></td>
                    <td style={{color:'var(--text-2)',fontSize:12}}>{l.added_by||'—'}</td>
                    <td onClick={e=>e.stopPropagation()} style={{display:'flex',gap:5,alignItems:'center'}}>
                      {l.status==='new' && (
                        <button className="btn btn-primary btn-sm" disabled={sending[l.id]}
                          onClick={e=>handleSend(l.id,e)}>
                          {sending[l.id]?<span className="spinner spinner-sm"/>:'Send'}
                        </button>
                      )}
                      <button className="btn btn-sm" title="Edit lead"
                        onClick={e=>{e.stopPropagation();setEditing(l);}}>
                        ✎
                      </button>
                      <button className="btn btn-sm" title="Add to contacts"
                        onClick={async e=>{e.stopPropagation();await handleAddToContacts([l.id]);}}>
                        👥
                      </button>
                      <button className="btn btn-danger btn-sm"
                        onClick={e=>handleDelete(l.id,e)}>✕</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Pagination */}
      {!loading && counts.total > 0 && (
        <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginTop:16,flexWrap:'wrap',gap:8}}>
          <div style={{fontSize:12,color:'var(--text-2)'}}>
            Showing {(page-1)*PAGE_SIZE+1}–{Math.min(page*PAGE_SIZE,counts.total)} of {counts.total}
          </div>
          <div style={{display:'flex',gap:6,alignItems:'center'}}>
            <button className="btn btn-sm" disabled={page<=1} onClick={()=>goToPage(page-1)}>← Prev</button>
            <span style={{fontSize:12,color:'var(--text-2)',padding:'0 6px'}}>Page {page} of {totalPages}</span>
            <button className="btn btn-sm" disabled={page>=totalPages} onClick={()=>goToPage(page+1)}>Next →</button>
          </div>
        </div>
      )}
    </>
  );
}
